export default __webpack_public_path__ + "static/media/step1.281ad7e2.png";